/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Test_SendInputs */

const cs_sms_test_send = /** @type {(inputs: Sms_Test_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat testovací SMS`)
};

const en_sms_test_send = /** @type {(inputs: Sms_Test_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send test SMS`)
};

/**
* | output |
* | --- |
* | "Send test SMS" |
*
* @param {Sms_Test_SendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_test_send = /** @type {((inputs?: Sms_Test_SendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Test_SendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_test_send(inputs)
	return cs_sms_test_send(inputs)
});